module.exports = __webpack_public_path__ + "img/cp-library-fisheries-2.736ac2b0.svg";